import { useState, useEffect, useCallback } from 'react';
import { getErpData, saveErpData } from '../../Services/app/erpservice';

// Loads one or more ERP collections from ThingsBoard and exposes a save helper.
//
//   const { data, loading, error, save, reload } = useErp({ items: ERP_KEYS.inventory });
//   data.items  -> the array (defaults to [])
//   save('items', nextArray)  -> persists to ThingsBoard and updates local state
//
// `keys` must be a stable object (define it at module scope, not inline).
export function useErp(keys) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setError(null);
    const entries = Object.entries(keys);
    Promise.all(entries.map(([, k]) => getErpData(k, [])))
      .then((results) => {
        const out = {};
        entries.forEach(([name], i) => { out[name] = Array.isArray(results[i]) ? results[i] : []; });
        setData(out);
      })
      .catch((e) => setError(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = useCallback(async (name, value) => {
    await saveErpData(keys[name], value);
    setData((prev) => ({ ...(prev || {}), [name]: value }));
    return value;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, loading: data === null && !error, error, save, reload: load };
}
